export default __webpack_public_path__ + "static/media/calendar.25df6c94.svg";